import React, {Dispatch, SetStateAction, useState, useEffect} from 'react'
import {Modal} from 'react-bootstrap'
import { useMutation, useQueryClient } from 'react-query'
import { KTSVG, QUERIES } from '../../../../../../_metronic/helpers'
import { useQueryResponse } from '../core/QueryResponseProvider'
import { Chat } from '../core/_models'
import { deleteChat, deleteMultipleChats } from '../core/_requests'
import { useListView } from '../core/ListViewProvider'
import { useCompanies } from '../../../../auth/core/Companies'

type Props = {
  show: boolean,
  action : boolean
  chat : Chat
  handleClose: () => void
  deleteQuery: () => void
}

const DeleteWarningModal: React.FC<Props> = ({show, handleClose, deleteQuery ,  chat,action}) => {
  const {query} = useQueryResponse()
  const queryClient = useQueryClient()
  const {defaultCompany} = useCompanies()
  const {selected, clearSelected,setStatusModal} = useListView()

  const updateStatus = useMutation(() => deleteChat(chat._id,defaultCompany?.company_id ?? ''), {
    // 💡 response of the mutation is passed to onSuccess
    onSuccess: () => {
      // ✅ update detail view directly
      queryClient.invalidateQueries([`${QUERIES.USERS_LIST}-${query}`])
      handleClose()
    },
  })

  const deleteSelectedItems = useMutation(() => deleteMultipleChats(selected,defaultCompany?.company_id ?? ''), {
    // 💡 response of the mutation is passed to onSuccess
    onSuccess: () => {
      // ✅ update detail view directly
      queryClient.invalidateQueries([`${QUERIES.USERS_LIST}-${query}`])
      clearSelected()
      handleClose()

    },
  })


  


  return (
    <Modal
      className='modal fade'
      id='kt_modal_select_location'
      data-backdrop='static'
      tabIndex={-1}
      role='dialog'
      show={show}
      dialogClassName='modal-xs mt-10'
      aria-hidden='true'
      onHide={handleClose}
    >
      <div className='modal-content'>
        <div className='modal-header'>
          <h5 className='modal-title'>Delete Chat </h5>

          <div className='btn btn-icon btn-sm btn-active-light-primary ms-2' onClick={handleClose}>
            <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-2x' />
          </div>
        </div>
        <div className='modal-body'>
          <p>Are you sure want to delete this chat?</p>
        </div>
        <div className='modal-footer'>
          <button
            type='button'
            className='btn btn-light-primary'
            onClick={() => handleClose()}
          >
            No
          </button>
          <button
            id='submit'
            type='button'
            className='btn btn-primary'
            onClick={async () => {
              if(action){
                await deleteSelectedItems.mutateAsync()  
                          }else{
                updateStatus.mutateAsync()
              }
            }}
          >
            Yes
          </button>
        </div>
      </div>
    </Modal>
  )
}

export {DeleteWarningModal}
